module.exports = __webpack_public_path__ + "static/media/wall.dd5cb176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall.jpg
// module id = 644
// module chunks = 0